export default __webpack_public_path__ + "static/media/img_step_lucia07-02.9cc00f0f.png";